import {useTranslation} from 'react-i18next';
import {Maximize, Sun, EyeOff, ScanFace, Glasses, Scan, ScanLine} from 'lucide-react';
import {cn} from '@chekinapp/ui';
import {useCaptureModeStore} from '../../../components/capture/useCaptureModeStore';

const HINTS = {
  document: [
    {icon: Sun, key: 'capture_hint.good_lighting'},
    {icon: EyeOff, key: 'capture_hint.no_glare'},
    {icon: Maximize, key: 'capture_hint.all_corners_visible'},
  ],
  codeSide: [
    {icon: ScanLine, key: 'capture_hint.code_visible'},
    {icon: EyeOff, key: 'capture_hint.no_glare'},
    {icon: Sun, key: 'capture_hint.good_lighting'},
  ],
  face: [
    {icon: Sun, key: 'capture_hint.good_lighting'},
    {icon: ScanFace, key: 'capture_hint.face_the_camera'},
    {icon: Glasses, key: 'capture_hint.no_sunglasses'},
  ],
  qr: [
    {icon: Sun, key: 'capture_hint.good_lighting'},
    {icon: EyeOff, key: 'capture_hint.no_glare'},
    {icon: Scan, key: 'capture_hint.fill_the_frame'},
  ],
  crop: [
    {icon: Maximize, key: 'capture_hint.all_corners_visible'},
    {icon: EyeOff, key: 'capture_hint.no_glare'},
    {icon: Sun, key: 'capture_hint.text_readable'},
  ],
} as const;

export function CaptureHints({
  variant = 'document',
  className,
}: {
  variant?: keyof typeof HINTS;
  className?: string;
}) {
  const {t} = useTranslation();
  const isCropping = useCaptureModeStore(state => state.mode) === 'crop';
  const hints = HINTS[isCropping ? 'crop' : variant];

  return (
    <div className={cn('flex flex-wrap justify-center gap-2', className)}>
      {hints.map(({icon: Icon, key}) => (
        <span
          key={key}
          className="inline-flex h-[30px] items-center gap-1.5 rounded-full bg-[var(--chekin-color-white)] px-[13px] text-[11.5px] font-medium text-[var(--chekin-color-gray-1)]"
        >
          <Icon className="size-4 text-[var(--chekin-color-brand-blue)]" />
          {t(key)}
        </span>
      ))}
    </div>
  );
}
